import { EValidationRegex } from '@/enums/ValidationRegex';
import { IValidationOption } from '@/dealroom/fields/types/validation-option';

export const validationOptions: IValidationOption[] = [
  {
    label: 'street-address',
    regex: EValidationRegex.Address,
  },
  {
    label: 'phone-international',
    regex: EValidationRegex.Phone,
  },
  {
    label: 'email',
    regex: EValidationRegex.Email,
  },
  {
    label: 'date-mm-dd-yyyy',
    regex: EValidationRegex.UsDate,
  },
  {
    label: 'date-yyyy-mm-dd',
    regex: EValidationRegex.SeDate,
  },
  {
    label: 'only-numbers',
    regex: EValidationRegex.Numbers,
  },
  {
    label: 'phone-us',
    regex: EValidationRegex.UsPhone,
  },
  {
    label: 'website',
    regex: EValidationRegex.Website,
  },
  {
    label: 'zip-code-us',
    regex: EValidationRegex.ZipCode,
  },
  {
    label: 'state-us',
    regex: EValidationRegex.UsState,
  },
  {
    label: 'us-ssn-canadian-sin',
    regex: EValidationRegex.UsSsnCaSin,
  },
  {
    label: 'custom',
    regex: EValidationRegex.Custom,
  },
];
